{
  "version": 1,
  "asset_id": "238b3a32-2aba-4096-ba98-8f3665d7f9f9",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/238b3a32-2aba-4096-ba98-8f3665d7f9f9/clip-img_0011.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/238b3a32-2aba-4096-ba98-8f3665d7f9f9/clip-img_0011.mp4",
  "original_filename": "clip-img_0011.mp4",
  "size": 502573,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:19Z"
}
